import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../../lib/cn';
import { useUiStore } from '../../../store/ui.store';
import { Tooltip } from '../../ui/Tooltip';
import { NavItem } from './navItems';

export interface SidebarNavItemProps {
  item: NavItem;
  onNavigate?: () => void;
}

export function SidebarNavItem({ item, onNavigate }: SidebarNavItemProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const selected = location.pathname.startsWith(item.path);

  const button = (
    <button
      type="button"
      onClick={() => {
        navigate(item.path);
        onNavigate?.();
      }}
      aria-label={collapsed ? item.label : undefined}
      className={cn(
        'mb-0.5 flex items-center gap-3 rounded-xl py-2.5 text-left text-sm',
        collapsed ? 'mx-auto w-9 justify-center px-0' : 'mx-1 w-[calc(100%-8px)] px-3',
        selected ? 'bg-primary-light font-bold text-primary-dark' : 'font-medium text-text-secondary hover:bg-surface-hover',
      )}
    >
      <span className="relative shrink-0">
        <item.icon size={18} className={selected ? 'text-primary' : 'text-text-tertiary'} />
        {collapsed && !!item.badgeCount && (
          <span className="absolute -right-1.5 -top-1.5 flex h-[14px] min-w-[14px] items-center justify-center rounded-full bg-error px-0.5 text-[8.5px] font-bold text-white">
            {item.badgeCount}
          </span>
        )}
      </span>
      {!collapsed && (
        <>
          <span className="flex-1 truncate">{item.label}</span>
          {!!item.badgeCount && (
            <span className="flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-error px-1 text-[10.5px] font-bold text-white">
              {item.badgeCount}
            </span>
          )}
        </>
      )}
    </button>
  );

  return collapsed ? <Tooltip label={item.label}>{button}</Tooltip> : button;
}
